import bootLayout from 'static/script/app/boot/boot-layout';
import bootItemResultList from 'static/script/app/boot/boot-item-result-list';
import Adsense from 'static/script/app/ui/adsense';
import CustomResultPageUi from 'static/script/app/ui/search-result/custom-result-page-ui';
import CustomResultPageUiTarget from 'static/script/app/ui/search-result/custom-result-page-ui-target';
import CollapsedParagraph from 'static/script/app/ui/search-result/collapsed-paragraph';
import CampaignTickerService from 'static/script/app/data/campaign-ticker-service';

module.exports = initData => {
    bootLayout(initData);
    bootItemResultList(initData);
    CampaignTickerService.attachTo(document);
    CustomResultPageUi.attachTo('[data-custom-result-page-banner]');
    CustomResultPageUiTarget.attachTo('[data-custom-result-page-banner-target]');
    CollapsedParagraph.attachTo('[data-collapsed-paragraph]');

    if (Adsense !== 'blocked!') {
        Adsense.attachTo('.adsense', { channel: 'search' });
    }
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/custom-results.js